import { Injectable } from '@angular/core';

@Injectable()
export class SelectBoxDefaultOptions {
  public allowFilter? = true;
  public filterPlaceholder = '请输入关键字';
  public maxVisibleItemCount? = 3;
  public allowParentSelection = true;
  public idField? = 'id';
  public textField? = 'name';
  public childrenField? = 'children';
}
